/**
 * Sorts alternatives:
 *   1. Premium products (is_premium === true) first.
 *   2. Within premium: descending by value-for-money rating. The rating is
 *      read from alt.reviews.by_field.rating_value (profile page shape) and
 *      falls back to alt.by_field.rating_value (alternatives page shape).
 *      Missing/non-numeric values are treated as 0 and rank last within the
 *      premium block.
 *   3. Within non-premium: descending by user rating rank
 *      ((rating_avg || 0) * (num_reviews || 0) * 10).
 *   4. Stable sort preserves input (BX-API) order for ties.
 */
const getRatingRank = alternative => (alternative.rating_avg || 0) * (alternative.num_reviews || 0) * 10

const getValueForMoney = alternative => {
  const raw = alternative?.reviews?.by_field?.rating_value ?? alternative?.by_field?.rating_value
  return Number(raw) || 0
}

const sortAlternatives = list =>
  [...list].sort((a, b) => {
    if (a.is_premium !== b.is_premium) return a.is_premium ? -1 : 1
    if (a.is_premium) {
      return getValueForMoney(b) - getValueForMoney(a)
    }
    return getRatingRank(b) - getRatingRank(a)
  })

export default sortAlternatives
